import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslatedToastrService, ValidationHandlerService, ModalBaseComponent } from 'lib/Vestra.shared';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { CoreService, LanguageEditModel, MessageListModel, MessageSentType } from 'src/app/services/api-services';
import { NgxSpinnerService } from 'ngx-spinner';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
@Component({
    selector: 'app-notification-sent-message-edit',
    templateUrl: './notification-sent-message-edit.component.html',
    styleUrls: ['./notification-sent-message-edit.component.scss'],
})
export class NotificationSentMessageEditComponent extends ModalBaseComponent {
    showModal: boolean = true;

    constructor(
        public bsModalRef: BsModalRef,
        private translatedToastrService: TranslatedToastrService,
        protected override validationHandlerService: ValidationHandlerService,
        protected override modalService: BsModalService,
        private coreService: CoreService,
        protected override spinnerService: NgxSpinnerService,
        private translateService: TranslateService
    ) {
        super(spinnerService, modalService, validationHandlerService);
    }
    //input properties
    public title: string;
    public item: MessageListModel;

    get isEmailEmpty(): boolean {
        const email = this.form.get('email')?.value;
        return !email || email.trim() === '';
    }
    get isEmailType(): boolean{
        return this.item.sentType == MessageSentType.Email;
    }

    private getFormGroup(): FormGroup {
        return new FormGroup({
            fullName: new FormControl({ value: '', disabled: true }, [Validators.required]),
            from: new FormControl({ value: '', disabled: true }, [Validators.required]),
            email: new FormControl({ value: '', disabled: true }, [Validators.required]),
            subject: new FormControl({ value: '', disabled: true }, [Validators.required]),
            status: new FormControl({ value: '', disabled: true }, [Validators.required]),
            sentType: new FormControl({ value: '', disabled: true }, [Validators.required]),
            type: new FormControl({ value: '', disabled: true }, [Validators.required]),
            body: new FormControl({ value: '', disabled: true }, [Validators.required]),
            attachments: new FormControl({ value: '', disabled: true }, [Validators.required]),
        });
    }
    public form: FormGroup = this.getFormGroup();

    public init() {
        this.form = this.getFormGroup();
        if (this.item) {
            if (this.item && this.item.attachments) {
                const raw = Array.isArray(this.item.attachments) ? this.item.attachments.join(', ') : this.item.attachments;
                try {
                    this.item.attachments = raw.replace(/\\u([\d\w]{4})/gi, (match, grp) => 
                        String.fromCharCode(parseInt(grp, 16))
                    );
                } catch (e) {
                    this.item.attachments = raw; 
                }
            }
            if(!this.item.attachments)
            {
                this.item.attachments = this.translateService.instant("notification.email_no_attachments_added")
            }
            this.form.patchValue(this.item);
            if(this.item.sentType == MessageSentType.Email)
            {
                this.handleSpinner(
                firstValueFrom(this.coreService.getMessageContent(this.item.id))
                    .then(res => {
                        this.item.body = res.result;
                        this.form.patchValue({
                            body: this.item.body
                        });
                        return Promise.resolve(res);
                    })
                    .catch((error: any) => {
                        this.validationHandlerService.handleServerError(error, this.form);
                    })
                );
            }
        }
    }

    public ngAfterViewInit() {
        this.init();
    }
    public onOpenEmailView() {
        const blob = new Blob([this.item.body], { type: 'text/html' });
        const blobUrl = URL.createObjectURL(blob);

        const previewWindow = window.open(blobUrl, '_blank');

        if (previewWindow) {
            previewWindow.onload = () => {
                URL.revokeObjectURL(blobUrl);
            };
        }
        else
        {
            this.translatedToastrService.error('common.failed_to_load_view', 'common.error');
        }
    }

    public onCancel() {
        this.showModal = true;
    }
    public onDelete = async (): Promise<any> => {
        if (!this.item) {
            this.translatedToastrService.error('common.error', 'common.warning');
            return;
        }
        return this.handleSpinner(
            firstValueFrom(this.coreService.deleteMessage(this.item.id))
                .then(res => {
                    this.onClose(this.bsModalRef, 'save_success');
                    return Promise.resolve(res);
                })
                .catch((error: any) => {
                    this.validationHandlerService.handleServerError(error, this.form);
                })
        );
    };
    public getValueFromEnum(type: any): string {
        switch (type) {
            case 'status':
                return 'notification.message_status_type_' + this.toSnakeCase(this.item.status);
            case 'type':
                return 'notification.message_type_' + this.toSnakeCase(this.item.type);
            case 'sentType':
                return 'notification.message_sent_type_' + this.toSnakeCase(this.item.sentType);
            default:
                return '-';
        }
    }
    public toSnakeCase(str: string): string {
        return str
            .replace(/([A-Z])/g, '_$1')
            .toLowerCase()
            .replace(/^_/, '');
    }
}
